<template>
	<div :id="'parent_element' + random_id" style="margin-left: 10.8cm !important">
		<div :id="'preview_cont' + id" style="width: 100%" ref="pdfViewer"></div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import { uuid } from "@/modules/builder/utils/utils"
import { getCustomFieldValue } from "@/utils/customfield"
/*
 *
 * spiegazione rapida
 *
 * il file non è altro che il template di render utilizzato da Renderer
 * il valore dell'editor di testo è pushato sullo store, viene passato un identificativo a questo componente, che poi recupera il valore dallo store.
 * essendo html non è possibile facilemtne passarlo direttamente quundi ho optato per questa soluzione
 * per il resto non fa nulla di che
 *
 *
 * */
export default {
	name: "Preview",
	props: {
		route: {
			type: String,
			required: true
		},
		documentId: {
			type: String,
			required: false
		},
		value: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			showPopover: false,
			random_id: undefined,
			varName: "",
			varType: "",
			varWiki: undefined,
			varList: undefined,
			spans: [],
			spanArray: [],
			id: this.uuid(),
			idArray: [],
			isFullLoaded: false
		}
	},
	computed: {
		...mapGetters({
			componente: "object/component",
			variabili: "prose/variables",
			normalizedVariables: "compilation/variables",
			loaded: "compilation/loaded",
			settings: "modules/settings",
			owners: "compilation/owners",
			is_compilation_running: "compilation/is_compilation_running"
		})
	},
	watch: {
		normalizedVariables(val) {
			if (val.length && this.isFullLoaded) {
				this.autoCompile()
			}
		}
	},

	async mounted() {
		this.openload()
		if (this.value !== undefined && this.value !== "") {
			// this.resetVariables();

			this.$refs.pdfViewer.innerHTML = this.componente(this.value).docContent
			// await this.initFields();
			//specifichiamo, la modifica dovrebbe essere fatta sul file ts di tiptap per far ritornare un tag table corretto
			//viste le difficoltà, questo è un workaround

			let tmpList = Array.from(document.getElementsByTagName("table"))

			if (tmpList.length > 0) {
				tmpList.forEach(tmp => {
					tmp.setAttribute("cellspacing", "0")
					tmp.setAttribute("cellpadding", "0")
					tmp.setAttribute("border", "1")
				})
			}

			//   cellspacing="0" cellpadding="0" border="1"
		}
		this.random_id = this.uuid()
		if (this.normalizedVariables.length) {
			setTimeout(this.autoCompile, 500)
			this.isFullLoaded = true
		} else {
			this.closeload()
		}
	},

	methods: {
		uuid,
		getCustomFieldValue,
		...mapActions({
			pushvar: "prose/doPush"
		}),
		...mapMutations({
			resetVariables: "prose/RESET_VARIABLES",
			setCompilation: "compilation/SET_COMPILATION",
			openload: "modules/OPEN_LOADING",
			closeload: "modules/CLOSE_LOADING"
		}),
		async autoCompile() {
			if (!this.is_compilation_running) {
				this.setCompilation(true)
				for (const variable of this.normalizedVariables) {
					if (!(variable.node_value && variable.node_value.value !== undefined)) continue

					const rawValue =
						variable.node.rules &&
						variable.node.rules.computed_rules &&
						variable.node.rules.computed_bool &&
						variable.node.custom_field_value !== null &&
						variable.node.custom_field_value.og !== undefined &&
						variable.node.rules.computed_rules.some(rule => rule.includes("val"))
							? variable.node.custom_field_value.og
							: variable.node_value.value

					let value = ""

					if (
						(this.route.includes("/fill/") || [-1, 0].includes(variable.node.level)) &&
						variable.node.rules.computed_bool
					) {
						value = await this.getCustomFieldValue(
							variable.node.rules.computed_rules,
							this.settings,
							this.owners,
							rawValue
						).then(val => {
							return val
						})
					} else {
						value = rawValue
					}

					this.saveField(value, variable)
				}
				this.setCompilation(false)
			}

			this.closeload()
			return true
		},
		saveField(val, field) {
			const target = Array.from(document.querySelectorAll(`[id^='x_${field.node.id}']`))

			target.forEach(span => {
				const {
					node: { rules = {} }
				} = field

				if (field.node.type === "number") {
					val = val.toString().replaceAll(".", ",")

					var vals = val.split(",")

					if (vals[1]) {
						if (vals[1].length <= 1) {
							vals[1] += "0"
						}
					} else {
						if (field.node) {
							if (field.node.rules) {
								if (field.node.rules.step) {
									let splitted = String(field.node.rules.step).split(".")
									if (splitted.length > 1) vals[1] = new Array(splitted[1].length + 1).join("0")
								}
							}
						}
					}

					if (!vals[0]) {
						vals[0] = "0"
					}

					val = vals.join(",")
				}

				if (field.node.type === "image" && field.node_value_file) {
					const width = rules.width ? `width="${rules.width}"` : ""
					const height = rules.height ? `height="${rules.height}"` : ""
					span.innerHTML = `<img src="data:image/png;base64,${field.node_value_file}" ${width} ${height} />`
					span.style.border = "none"
				} else {
					span.innerText = val.length === 0 ? `{${field.node.name}}` : val
					span.style.border = "1px solid red"
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
table {
	border-collapse: collapse;
	table-layout: fixed;
	width: 100%;
	margin: 0;
	overflow: hidden;

	td,
	th {
		min-width: 1em;
		border: 2px solid #bec6cd;
		padding: 3px 5px;
		vertical-align: top;
		box-sizing: border-box;
		position: relative;

		> * {
			margin-bottom: 0;
		}
	}

	th {
		font-weight: bold;
		text-align: left;
		background-color: #f1f3f5;
	}

	.selectedCell:after {
		z-index: 2;
		position: absolute;
		content: "";
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(200, 200, 255, 0.4);
		pointer-events: none;
	}

	.column-resize-handle {
		position: absolute;
		right: -2px;
		top: 0;
		bottom: -2px;
		width: 4px;
		background-color: #adf;
		pointer-events: none;
	}
}

@page {
	size: auto;
	margin: 0;
}

.page-container {
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 50px;
	padding: 15px;
	align-items: center;
	overflow: hidden;
}
</style>

<style lang="scss" scoped>
table {
	border-collapse: collapse;
	table-layout: fixed;
	width: 100%;
	margin: 0;
	overflow: hidden;

	td,
	th {
		min-width: 1em;
		border: 2px solid #0089ff !important;
		padding: 3px 5px;
		vertical-align: top;
		box-sizing: border-box;
		position: relative;

		> * {
			margin-bottom: 0;
		}
	}

	th {
		font-weight: bold;
		text-align: left;
		background-color: #007fff;
	}

	.selectedCell:after {
		z-index: 2;
		position: absolute;
		content: "";
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(200, 200, 255, 0.4);
		pointer-events: none;
	}

	.column-resize-handle {
		position: absolute;
		right: -2px;
		top: 0;
		bottom: -2px;
		width: 4px;
		background-color: #adf;
		pointer-events: none;
	}
}

@page {
	size: auto;
	margin: 0;
}

.page-container {
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 50px;
	padding: 15px;
	align-items: center;
	overflow: hidden;
}
</style>
